import {
  arrayBuilderItemSubsequentPageTitleUI,
  textareaUI,
  textUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import {
  arrayOptions,
  createNewConditionName,
  disallowWhitespaceOnly,
} from './utils';
import { trackCauseCharLimit } from '../../../utils/tracking/features/causeCharLimitTracking';

/** @returns {PageSchema} */
const causeVAPage = {
  uiSchema: {
    ...arrayBuilderItemSubsequentPageTitleUI(
      ({ formData } = {}) => createNewConditionName(formData, true),
      undefined,
      false,
    ),
    vaMistreatmentDescription: {
      ...textareaUI({
        title:
          'Briefly describe the injury or event in VA care that caused your condition.',
        updateUiSchema: (_formData, fullData, index) => {
          const item = fullData?.[arrayOptions.arrayPath]?.[index] || {};

          return {
            'ui:title': `Briefly describe the injury or event in VA care that caused your ${createNewConditionName(
              item,
            )}.`,
          };
        },
        charcount: true,
      }),
      'ui:validations': [
        disallowWhitespaceOnly,
        // limit mirrors the schema maxLength below
        trackCauseCharLimit({
          field: 'vaMistreatmentDescription',
          cause: 'VA',
          limit: 800,
        }),
      ],
    },
    vaMistreatmentLocation: {
      ...textUI({
        title: 'Tell us where this happened.',
        charcount: true,
      }),
      'ui:validations': [
        disallowWhitespaceOnly,
        // limit mirrors the schema maxLength below
        trackCauseCharLimit({
          field: 'vaMistreatmentLocation',
          cause: 'VA',
          limit: 100,
        }),
      ],
    },
  },

  schema: {
    type: 'object',
    properties: {
      vaMistreatmentDescription: {
        type: 'string',
        maxLength: 800,
      },
      vaMistreatmentLocation: {
        type: 'string',
        maxLength: 100,
      },
    },
    required: ['vaMistreatmentDescription', 'vaMistreatmentLocation'],
  },
};

export default causeVAPage;
